import { createAction } from "@reduxjs/toolkit";
import { SmtpConfigDto } from "api/ConfigApi";

export const getSmtpConfigs = createAction("getSmtpConfigs");

export const saveSmtpConfigs = createAction<SmtpConfigDto>("saveSmtpConfigs");
